export default __webpack_public_path__ + "static/media/bg_play_failed.66222cd3.jpg";